import React, { useState } from 'react'
import { Formik } from 'formik'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import FormSelect from '../../atoms/FormSelect/FormSelect'
import FormTextarea from '../../atoms/FormTextarea/FormTextarea'
import Button from '../../atoms/Button/Button'
import getValidationSchema from './validationSchema'
import { api } from '../../../utils/index'
import { RICHIESTACATALOGO } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import { Router, useRouter } from 'next/router'
import { Breadcrumbs, MetaSeo, Trans } from '../../../components/index'
import QuantityHandler from '../../atoms/QuantityHandler/QuantityHandler'
import { useSelector } from 'react-redux'
import usePrivacy from '../../../hooks/usePrivacy'
import { trackingGAEvent } from '../../../utils/gtm'

const FormRichiestaCatalogo = ({ cataloghi, page }) => {
  const t = useTrans()
  const router = useRouter()
  const { getUrlInformativaFromStore } = usePrivacy()
  const { service_gift } = useSelector((state) => state.servicegift)

  const validationSchema = getValidationSchema()
  const initialValues = {
    azienda: null,
    nome: null,
    email: null,
    telefono: null,
    catalogo: null,
    note: null,
    quantita: 0,
  }

  return (
    <div className="page">
      <MetaSeo seo={page.seo} />
      <div className="w-container">
        <div className="richiesta-catalogo-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          <h2 className="page__title">{t('Richiesta catalogo personalizzato')}</h2>
          <p className="richiesta-catalogo-container__description">
            {t('Compila tutti i campi per inviare la richiesta del catalogo personalizzato')}
          </p>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            validateOnMount={true}
            onSubmit={(values) => {
              try {
                const catalogo = cataloghi.find(catalogo => catalogo.id === values.catalogo)?.titolo
                const params = {
                  azienda: values.azienda,
                  nome: values.nome,
                  email: values.email,
                  telefono: values.telefono,
                  catalogo: catalogo,
                  quantita: values.quantita,
                  note: values.note ? values.note : '',
                }
                api
                  .post(RICHIESTACATALOGO, params)
                  .then((res) => {
                    router.push(`/richiesta-catalogo/success`)
                  })
                  .catch((error) => console.log(error))
              } catch (error) {
                console.log(error)
              }
            }}
          >
            {(props) => (
              <div className="richiesta-catalogo-container__form">
                <div className="richiesta-catalogo-container__fields">
                  <div className="richiesta-catalogo-container__field">
                    <FormField
                      label={t('Azienda *')}
                      status={
                        props.touched.azienda && props.errors.azienda
                          ? 'error'
                          : props.touched.azienda && 'success'
                      }
                      errorMessage={props.errors?.azienda}
                      id="richiestacatalogo_azienda"
                    >
                      <FormInput
                        value={props.values.azienda}
                        onBlur={props.handleBlur('azienda')}
                        onChange={props.handleChange('azienda')}
                        id="richiestacatalogo_azienda"
                      />
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field">
                    <FormField
                      label={t('Nome e cognome *')}
                      status={
                        props.touched.nome && props.errors.nome
                          ? 'error'
                          : props.touched.nome && 'success'
                      }
                      errorMessage={props.errors?.nome}
                      id="richiestacatalogo_nome"
                    >
                      <FormInput
                        name="nome"
                        value={props.values.nome}
                        onBlur={props.handleBlur('nome')}
                        onChange={props.handleChange('nome')}
                        id="richiestacatalogo_nome"
                      />
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field">
                    <FormField
                      label={t('e-mail *')}
                      status={
                        props.touched.email && props.errors.email
                          ? 'error'
                          : props.touched.email && 'success'
                      }
                      errorMessage={props.errors?.email}
                      id="richiestacatalogo_email"
                    >
                      <FormInput
                        value={props.values.email}
                        onBlur={props.handleBlur('email')}
                        onChange={props.handleChange('email')}
                        id="richiestacatalogo_email"
                      />
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field">
                    <FormField
                      label={t('Telefono *')}
                      status={
                        props.touched.telefono && props.errors.telefono
                          ? 'error'
                          : props.touched.telefono && 'success'
                      }
                      errorMessage={props.errors?.telefono}
                      id="richiestacatalogo_telefono"
                    >
                      <FormInput
                        type="number"
                        value={props.values.telefono}
                        onBlur={props.handleBlur('telefono')}
                        onChange={props.handleChange('telefono')}
                        id="richiestacatalogo_telefono"
                      />
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field">
                    <FormField
                      label={t('Catalogo *')}
                      status={
                        props.touched.catalogo && props.errors.catalogo
                          ? 'error'
                          : props.touched.catalogo && 'success'
                      }
                      errorMessage={props.errors?.catalogo}
                      id="richiestacatalogo_catalogo"
                    >
                      <div className="field-content__catalogo">
                        <FormSelect
                          isSearchable={true}
                          placeholder={t('Seleziona Catalogo')}
                          options={
                            cataloghi &&
                            cataloghi.map((obj) => {
                              return {
                                label: obj.titolo,
                                value: obj.id,
                              }
                            })
                          }
                          value={props.values.catalogo}
                          onChange={(e) => {
                            props.setFieldValue('catalogo', e.target.value)
                          }}
                          onBlur={props.handleBlur('catalogo')}
                          id="richiestacatalogo_catalogo"
                        ></FormSelect>
                      </div>
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field">
                    <FormField label={t('Quantità *')} id="richiestacatalogo_quantita">
                      <QuantityHandler
                        inputDisabled={false}
                        value={props.values.quantita}
                        onValueChange={(newVal, action) => {
                          if (newVal >= 0) {
                            props.setFieldValue('quantita', newVal)
                          }
                        }}
                        id="richiestacatalogo_quantita"
                      />
                    </FormField>
                  </div>
                  <div className="richiesta-catalogo-container__field richiesta-catalogo-container__field--full">
                    <FormField
                      label={t('Note sulla richiesta ordine')}
                      status={
                        props.touched.note && props.errors.note
                          ? 'error'
                          : props.touched.note && 'success'
                      }
                      errorMessage={props.errors?.note}
                      id="richiestacatalogo_note"
                    >
                      <FormTextarea
                        placeholder={t(
                          'Inserisci informazioni relative alla richiesta del catalogo'
                        )}
                        onChange={props.handleChange('note')}
                        value={props.values.note}
                        id="richiestacatalogo_note"
                      />
                    </FormField>
                  </div>
                </div>

                {!service_gift?.attivo && (
                  <p style={{ fontSize: 14 }}>
                    {t('Contattandoci, dichiari di aver letto e compreso')}{' '}
                    <a
                      target="_blank"
                      style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                      href={getUrlInformativaFromStore()}
                    >
                      {t("l'Informativa Privacy")}
                    </a>
                  </p>
                )}
                <Button
                  disabled={!props.isValid}
                  label={t('Invia richiesta catalogo')}
                  variant="primary"
                  size="medium"
                  type="submit"
                  onClick={() => {
                    const catalogo = cataloghi.find(catalogo => catalogo.id === props.values.catalogo)?.titolo
                    trackingGAEvent('catalogue_request_sent', undefined, catalogo)
                    props.handleSubmit()
                  }}
                  className="richiesta-catalogo-container__submit"
                />
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
export default FormRichiestaCatalogo
